<ng-container *ngIf="!!element">
    <div *ngIf="element?.settings?.general?.text" class="wysiwyg" [class.is-rtl]="isRtl">
        <div class="wysiwyg-position">
            <ng-container
                *ngIf="element?.settings?.general?.buttonBarToggle && element?.settings?.general?.buttonBarPosition === 'up'; then buttonBar"
            >
            </ng-container>
            <render-wysiwyg
                [element]="element"
                [html]="element?.settings?.general?.text"
                [textPaddingTop]="element?.settings?.general?.textPaddingTop"
                [textPaddingBottom]="element?.settings?.general?.textPaddingBottom"
                [textPaddingLeft]="element?.settings?.general?.textPaddingLeft"
                [textPaddingRight]="element?.settings?.general?.textPaddingRight"
            >
            </render-wysiwyg>
            <span *ngIf="isTextDropdownEnabled" class="show-more" role="button" (click)="fullText()">
                {{ toggleExpandedText }}
            </span>
            <ng-container
                *ngIf="element?.settings?.general?.buttonBarToggle && element?.settings?.general?.buttonBarPosition === 'down'; then buttonBar"
            >
            </ng-container>
        </div>
    </div>

    <ng-template #buttonBar>
        <ul class="button-bar">
            <li *ngFor="let button of element?.settings?.general?.buttons; trackBy: trackByIndex">
                <render-link [link]="button?.link" [styleClass]="button?.style" [element]="element">
                    {{ button?.title }}
                </render-link>
            </li>
        </ul>
    </ng-template>
</ng-container>
